import Vue from "vue";
import Component from "vue-class-component";
import moment from "moment";
import $ from "jquery";
import { CalendarData } from "./types";
import { loadAppointments } from "./sessionService";
/* eslint-disable import/first */
(window as any).$ = (window as any).jQuery = require("jquery");
const signalrImport = import("signalr");

@Component
export default class signalRMixin extends Vue {
    data = [] as CalendarData[];
    midnightTimer = 0;

    // SignalR
    subscriptionStarted = false;
    subscribeRetries = 0;
    subscribeTimeout = 0;
    connectionStartRetries = 0;
    connection: any;
    hub: any = {};

    mountSignalR() {
        this.getDataMidnight(); // Hard reloads data at midnight

        signalrImport.then(() => {
            this.connection = $.hubConnection("http://localhost:8000/signalr");
            this.hub = this.connection.createHubProxy("CalendarComponentHub");
            this.connection.disconnected(this.connectionStart);

            this.hub.on("subscriptionEnded", () => {
                this.startSubscription(15000);
            });

            this.hub.on("errorOccured", (message: string) => {
                console.log("Error", "An error occured in subscription: " + message);
                if (!this.subscriptionStarted) this.startSubscription(30000);
            });

            this.hub.on("dataUpdated", () => {
                this.loadData(false);
            });
            this.loadData(true);
            this.connectionStart();
        });
    }

    beforeDestroy() {
        clearInterval(this.midnightTimer);
    }

    loadData(reload: boolean) {
        if ((this as any).isBookingDisabled) {
            return;
        }
        console.log("Getting data");
        loadAppointments({ fromDateTime: moment().format(), toDateTime: moment().format(), reload: reload }).then(response => {
            if (response) {
                this.data = response;
            }
        });
    };

    startSubscription(retryTimeout: number) {
        this.hub.invoke("subscribe").done((result: any) => {
            if (result) {
                this.subscriptionStarted = true;
                this.subscribeRetries = 0;
                console.log("Success", "Started connection");
                this.loadData(false);
            } else {
                console.log("Error", "Connection failed");
                this.subscriptionStarted = false;
                if (this.subscribeRetries === 5) {
                    clearTimeout(this.subscribeTimeout);
                    this.subscribeRetries = 0;
                    this.subscribeTimeout = setTimeout(() => { this.startSubscription(300000); }, retryTimeout);
                    console.log("Error", "Connection failed. Trying again in 5 minutes.");
                } else {
                    clearTimeout(this.subscribeTimeout);
                    this.subscribeTimeout = setTimeout(() => { this.startSubscription(30000); }, retryTimeout);
                    this.subscribeRetries++;
                    if (this.subscribeRetries > 0) console.log("Error", "Connection failed. Trying again in 30 seconds.");
                }
            };
        }).fail(() => {
            clearTimeout(this.subscribeTimeout);
            this.subscribeTimeout = setTimeout(() => { this.startSubscription(30000); }, retryTimeout);
            this.subscribeRetries++;
            console.log("Error", "Connection failed. Trying again in 30 seconds.");
        });
    }

    connectionStart() {
        this.connection.start({ jsonp: true }).done(() => {
            this.startSubscription(15000);
        }).fail(() => {
            var time = this.connectionStartGetRetryTime();
            setTimeout(this.connectionStart, time);
            this.connectionStartRetries++;
        });
    };

    connectionStartGetRetryTime() {
        if (this.connectionStartRetries <= 1) {
            return 30000;
        } else if (this.connectionStartRetries <= 3) {
            return 60000;
        } else if (this.connectionStartRetries >= 8) {
            return 60000 * 60;
        } else {
            return this.connectionStartRetries * this.connectionStartRetries * 1000;
        }
    }

    getDataMidnight() {
        clearTimeout(this.midnightTimer);
        var now = new Date();
        var night = new Date(
            now.getFullYear(),
            now.getMonth(),
            now.getDate() + 1, // the next day, ...
            0, 0, 0 // ...at 00:00:00 hours
        );
        var msTillMidnight = night.getTime() - now.getTime();
        this.midnightTimer = setTimeout(() => {
            console.log("It's midnight, doing a hard reload");
            this.loadData(true);
            this.getDataMidnight();
        }, msTillMidnight);
    }
}
